import React from 'react';
import styles from "./adYouTube.scss";
import { Tooltip } from 'antd';
import { getIconUrl } from '../../../services/asset';

const AdYouTube = ({isSearchPage}) => {
  
    return (
        <Tooltip title={"Oglas ima video."} 
                placement={"topRight"}>

            <img src={isSearchPage ? getIconUrl("youtube-white.svg") : getIconUrl("youtube-icon.svg")} 
                className={`${styles.youtubeIcon} 
                            ${isSearchPage ? 
                                styles.searchPageIcon : 
                                styles.regularIcon
                            }`
                           }
                alt={"YouTube"}
             /> 
        </Tooltip>
    );
}

export default AdYouTube;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdYouTube/AdYouTube.tsx